/**
 * Trigger a client-side file download of `text`. Everything stays on the
 * device — we wrap the string in a Blob, point a transient object URL at it,
 * and click a synthetic anchor, then revoke the URL a moment later — Firefox
 * and Safari can cancel the download if it is revoked on the next tick.
 *
 * No-ops outside a DOM (e.g. SSR/tests) so callers don't have to guard.
 */
export function downloadText(text: string, filename: string, mimeType = 'text/plain'): void {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') return;
  const url = URL.createObjectURL(new Blob([text], { type: mimeType }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
